import React from "react";
import './download-product.scss'
import {PRODUCT_STATUS_FREEBIE} from "../../../../libraries/download-panel-library";
import PropTypes from "prop-types";

/**
 * Renders htmls for the given product, used in Quality dropdown in download dialog
 *
 * @param {object} product
 * @param {boolean} product.needsPurchase
 * @param {string} product.status
 * @param {string} product.name
 * @param {string} product.hasWatermark
 * @param {string} product.price
 * @param {string} product.productCreditPrice
 * @param {string} product.description
 * @returns {JSX.Element}
 * @constructor
 *
 * @author Ahsan Ejaz <ahsan@250mils.com>
 */
const DownloadProduct = ({product}) => {
    let isPremium = PMW.getUserPremiumLevel() > 0;
    return (
        <div className={"product-item"}>
            <div className={'product-info'}>
                <span className={"item-name content-body"}>{product.name}</span>
                {product.needsPurchase && isPremium && <span className={"item-tag body-xxs-bold"}>{parseInt(product.productCreditPrice) === 1 ? i18next.t('pmwjs_1_credit') : i18next.t('pmwjs_x_credits', {'credits' : product.productCreditPrice})}</span>}
                {product.needsPurchase && !isPremium && <span className={"item-tag body-xxs-bold"}>{product.price}</span>}
                {!product.needsPurchase && product.status === PRODUCT_STATUS_FREEBIE && <span className={"item-tag body-xxs-bold"}>{i18next.t('pmwjs_free')}</span>}
                {product.hasWatermark && <span className={"item-tag -secondary body-xxs-bold"}>{i18next.t('pmwjs_watermark')}</span>}
            </div>
            <p className={"item-desc body-xs content-disabled"}>{product.description}</p>
        </div>
    )
}

DownloadProduct.propTypes = {
    /**
     * Object containg download product details (status, price, name etc)
     */
    product: PropTypes.object.isRequired
}


export default DownloadProduct;